import { render, staticRenderFns } from "./IFFinanicalReport.vue?vue&type=template&id=b09a61e0"
import script from "./IFFinanicalReport.vue?vue&type=script&lang=js"
export * from "./IFFinanicalReport.vue?vue&type=script&lang=js"
import style0 from "./IFFinanicalReport.vue?vue&type=style&index=0&id=b09a61e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports